<template>
  <header style="opacity: 0;">
    <Burger/>
    <Logo data-anim="fade">
      <div
        slot="logo"
        class="logo__wrapper apollo__link"
        @mouseenter="hover"
        @mouseleave="hover"
      >
        <h1 class="link"><span>P</span><span>y</span><span>g</span><span>a</span><span>r</span></h1>
        <h1 class="hover"><span>P</span><span>y</span><span>g</span><span>a</span><span>r</span></h1>
      </div>
    </Logo>
  </header>
</template>

<script>
import { TweenMax } from 'gsap/TweenMax';
import { hovers } from '@/assets/animations';

import Burger from '@/components/ui/Burger.vue';
import Logo from '@/components/ui/Logo.vue';

export default {
  name: 'Header',

  components: {
    Burger,
    Logo,
  },

  data() {
    return {
      anim: null,
    };
  },

  mounted() {
    const hover = Array.from(document.querySelectorAll('.hover span', this.$el));
    const tween = TweenMax.set(hover, {
      yPercent: 10,
      autoAlpha: 0,
    });
  },

  methods: {
    hover(event) {
      if (this.$route.name === 'index') return;

      const dir = event.type === 'mouseenter';

      if (dir) {
        if (this.anim === null) this.anim = hovers.get('logo')(this.$el);
        this.anim.play();
      } else {
        this.anim.reverse();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 25px;

  display: grid;
  grid-template-columns: 1fr rem(50px);
  grid-template-areas: 'a b';
  grid-template-rows: 1fr;

  align-items: center;

  z-index: 20;

  pointer-events: none;

  &__wrapper {
    position: relative;
    overflow: hidden;
  }

  @include mq(ipadP) {
    height: 180px;
    padding: rem(40px);
    grid-template-columns: rem(60px) 1fr;

    column-gap: rem(60px);
  }

  @include mq(ds) {
    padding: rem(60px);
  }

  h1 {
    @include fluid-type(375px, 1920px, 26px, 50px, 60px, 60px);

    span {
      display: inline-block;
    }

    &.hover {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
